const getters = {
  getArticleSearchResult: (state: any) => state.articleSearch.searchResult,
  getVideoByCategory: (state: any) => state.categorySearch.playList,
  getTimeUsing: (state: any) => state.momentClose - state.momentOpen,
  gethelpSystemSetting(state: any) {
    return state.gethelp;
  },
};

export default getters;
